import Vue from "vue";
import VueGtm from "@gtm-support/vue2-gtm";
import { NavigationGuardNext, Route, RouteConfig } from "vue-router";
import VueRouter from "./VueRouteOverride";
import processRoute from "./guard";

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  defer: false,
  enabled: true,
  debug: false,
  loadScript: true,
  trackOnNextTick: false,
});

Vue.use(VueRouter);
const router = (
  routes: Array<RouteConfig>,
  store: any /* Vuex.Store */,
  isAdmin = false
) => {
  const vueRouter = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
      {
        path: "/logout",
        name: "Logout",
        meta: {
          publicAccess: true,
        },
        async beforeEnter(to, from, next) {
          await store.dispatch("logout");
          return next({ name: "Login" });
        },
      },
      ...routes,
    ],
  });

  vueRouter.beforeEach(
    async (to: Route, from: Route, next: NavigationGuardNext) =>
      processRoute(to, from, next, store, isAdmin)
  );
  return vueRouter;
};
export default router;
